import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const submissionFormStyles = css`
  .field-container {
    .ant-form-item {
      display: flex;
      flex-direction: column;

      &.ant-form-item-has-success {
        .ant-form-item-children-icon {
          color: ${themeGet('primary.0', '#194AB9')};
        }
        &.ant-form-item-has-feedback {
          .ant-select .ant-select-selector {
            background-color: ${themeGet('color.1', '#ffffff')};
          }
          .ant-picker-suffix {
            margin-top: -3px;
            margin-right: 16px;
          }
        }
      }

      &.ant-form-item-has-error {
        .ant-select {
          .ant-select-selector {
            border-color: ${themeGet('border.3', '#E6E6E6')} !important;
          }
        }
        .ant-picker-suffix {
          margin-top: -3px;
          margin-right: 16px;
        }

        .ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) {
          .ant-select-selector {
            box-shadow: none !important;
          }
        }
      }

      .ant-form-item-label {
        text-align: left;
        margin-bottom: 2px;
        padding: 0 0 8px;
        label {
          color: ${themeGet('text.0', '#2C2C2C')};
          font-size: 14px;
          // font-weight: bold;
          line-height: 1.6;
        }
      }

      .ant-form-item-control {
        line-height: 1;

        .ant-form-item-control-input {
          input.ant-input {
            border-color: ${themeGet('default.0', '#e8eaec')};
            &:hover {
              border-color: ${themeGet('primary.0', '#194AB9')};
            }
          }
        }

        input {
          height: 47px;
          &:focus {
            outline: 0;
            box-shadow: none;
          }
        }

        textarea {
          &:focus {
            outline: 0;
            box-shadow: none;
          }
        }

        &.has-success {
          .ant-form-item-children-icon {
            color: ${themeGet('primary.0', '#008489')};
          }
        }
        .ant-picker {
          height: 47px;
          padding: 0 11px;
          display: block;
          border-color: ${themeGet('border.3', '#E6E6E6')};
          &.ant-picker-focused {
            box-shadow: none;
          }
          &:active,
          &:hover {
            border-color: ${themeGet('primary.0', '#008489')};
          }
        }

        .ant-select {
          &.ant-select-focused {
            outline: 0;
            box-shadow: none !important;
          }
          .ant-select-selector {
            border-radius: 3px;
            border-color: ${themeGet('border.3', '#E6E6E6')};
            height: 47px;
            box-shadow: none !important;
            .ant-select-selection-item,
            .ant-select-selection-placeholder {
              line-height: 47px;
            }
            &:active,
            &:hover {
              border-color: ${themeGet('primary.0', '#008489')} !important;
            }
          }
          &.ant-select-disabled {
            &.editmode {
              color: rgba(0, 0, 0, 0.65);
              .ant-select-selector {
                background: transparent;
                cursor: default;
              }
              .ant-input-disabled {
                color: rgba(0, 0, 0, 0.65);
                cursor: default;
              }
            }
          }
        }
        &.has-success.has-feedback {
          .ant-select .ant-select-selection--single,
          .ant-calendar-picker input {
            background-color: ${themeGet('color.2', '#F7F7F7')};
          }
        }
      }
    }
  }
`;

export const SubmissionWrapper = styled.div`
  .ant-alert {
    margin-bottom: 17px;
    align-items: flex-start;
    .ant-alert-icon {
      margin-top: 4px;
    }
  }
  &.finished {
    padding-top: 30px;
  }
  @media only screen and (max-width: 767px) {
    padding-top: 20px;
    padding-right: 0;
    padding-left: 0;
    padding-bottom: 80px;
    &.in-collapse {
      padding-top: 0;
      padding-bottom: 0;
    }
    &.no-payment {
      padding-bottom: 0;
    }
  }
`;

export const SubmissionTopSection = styled.div`
  ${submissionFormStyles};
  ${({ instantBook }) => {
    return instantBook ? css`` : css`};`;
  }}
`;

export const SubmissionBottomSection = styled.div`
  ${submissionFormStyles};
  position: relative;
  button {
    font-weight: bold;
    color: ${themeGet('text.3', '#8d8d8d')};
    &:hover {
      color: ${themeGet('primary.0', '#194AB9')};
    }
  }
`;

export const BottomSectionActions = styled.div`
  white-space: nowrap;
`;

export const SubmissionGroup = styled.div`
  margin-bottom: 36px;
  border-bottom: 1px solid ${themeGet('border.5', '#e8eaec')};
  @media only screen and (max-width: 767px) {
    padding-right: 20px;
    padding-left: 20px;
  }
  &.is-filled-form {
    border-bottom: 0;
    input,
    .ant-select-selection {
      border-radius: 2px;
      border-color: #e6e6e6;
    }
    textarea {
      border-radius: 2px;
      border-color: #e6e6e6;
    }
    @media only screen and (max-width: 767px) {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;
      h4,
      h5 {
        padding-right: 20px;
        padding-left: 20px;
      }
    }
  }
  .title-and-buttons {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    @media only screen and (max-width: 767px) {
      padding-right: 20px;
    }
    button {
      @media only screen and (max-width: 767px) {
        padding-right: 0;
      }
    }
  }
`;

export const RowWrapper = styled.div`
  padding: 0 30px 16px;
  @media only screen and (max-width: 767px) {
    padding: 0 0 16px;
  }
  &.filled-row {
    padding: 32.5px 28px 30px;
    border-top: 1px solid #e8eaec !important;
    background-color: ${themeGet('color.22', '#fafafa')};
    border: 1px solid ${themeGet('border.5', '#e8eaec')};
    border-radius: 2px;
    @media only screen and (max-width: 767px) {
      padding: 20px 20px 16px;
    }
  }
`;

export const GroupTitle = styled.h4`
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  color: black;
  margin-left: 30px;
  margin-bottom: 24px;
  @media only screen and (max-width: 767px) {
    margin-left: 0;
  }
`;

export const GroupBottomTitle = styled.h4`
  color: ${themeGet('text.4', '#323232')};
  margin-left: 30px;
  margin-bottom: 5px;
  font-size: 17px;
  font-weight: bold;
  line-height: 24px;
  @media only screen and (max-width: 767px) {
    margin-left: 0;
  }
`;

export const GroupBottomSubtitle = styled.h5`
  margin-left: 30px;
  font-size: 14px;
  line-height: 18px;
  color: ${themeGet('text.3', '#8d8d8d')};
  margin-bottom: 1em;
  @media only screen and (max-width: 767px) {
    margin-left: 0;
    margin-bottom: 20px;
  }
`;

export const FormFieldWithStatus = styled.div`
  .field-container {
    .ant-form-item {
      .ant-form-item-label {
        text-align: left;
        width: 100%;
        label {
          line-height: 39.9999px;
          @media only screen and (max-width: 574px) {
            line-height: 1.5;
          }
          &::after {
            display: none;
          }
        }
      }
    }
  }
  .label-with-status {
    display: flex;
    align-items: center;
    .anticon {
      margin-right: 5px;
    }
    button {
      margin-left: auto;
      font-weight: bold;
      height: 47px;
    }
    &.space-between {
      justify-content: space-between;
    }
  }
`;

export const MarinaStatus = styled.div`
  margin-left: 10px;
  font-weight: normal;
  color: ${themeGet('text.1', '#8d8d8d')};
`;

export const NotFound = styled.div`
  display: flex;
  align-items: center;
  span {
    margin-right: 5px;
  }
  button {
    padding: 0;
    height: 20px;
  }
`;

export const SuccessDialogActions = styled.div`
  button {
    height: 47px;
    font-size: 14px;
    font-weight: 700;
    padding-left: 28px;
    padding-right: 28px;
    min-width: 167px;
  }
`;

export const DocumentList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
  padding-bottom: 24px;
  padding-right: 0;
  padding-left: 0;

  @media only screen and (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  @media only screen and (max-width: 767px) {
    grid-template-columns: repeat(3, 1fr);
    padding-top: 10px;
    padding-bottom: 10px;
  }
  @media only screen and (max-width: 580px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (max-width: 479px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ErrorMessage = styled.p`
  color: ${themeGet('text.5', '#f5222d')};
  margin-bottom: 0;
`;
